import React, {Component, useState, useEffect} from "react";
import { Route, Switch, withRouter } from 'react-router-dom';
import {SearchView} from "./SearchView";
import Theme from "@amzn/meridian/theme";
import blueDarkTokens from "@amzn/meridian-tokens/theme/blue-dark";
import blueLightTokens from "@amzn/meridian-tokens/theme/blue-light";
import { getDarkModeStatus, setDarkModeStateListener } from "./handler/ParentDataHandler";
import { DARK_MODE } from "./constants/Constants";

function publishRoutePath(location) {

}

const AppComponent = () => {
    const [currentDarkMode, setCurrentDarkMode] = useState(DARK_MODE.LIGHT);
   
    useEffect(() => {
      setDarkModeStateListener(setCurrentDarkMode);
      getDarkModeStatus();
    }, []);

    return (
        <Theme tokens={currentDarkMode === DARK_MODE.DARK ? blueDarkTokens : blueLightTokens} >
            <Switch>
                <Route path="/" component={SearchView}/>
            </Switch>
        </Theme> 
    );
};

class App extends Component {
    componentWillMount() {
        publishRoutePath(this.props.location);
        this.onRouteSwitch = this.props.history.listen(() => {
            publishRoutePath(this.props.location);
        });
    }
    componentWillUnmount() {
        this.onRouteSwitch();
    }
    render() {
        return <AppComponent />;
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js